/* eslint-disable no-console */
/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { generateThumbnailFrmUtube, getYoutubeInfo } from '../HelperContent';
import { LanguageContext } from '../Context';

const useYoutubeURL = (youtubeObj) =>
{
	const {
		pasteUrl,
		setPasteUrl,
		setYouTubeData,
		setData,
		youTubeData,
		setError,
		type,
		handleClose
	} = youtubeObj;

	const { language } = useContext(LanguageContext);

	const handleUrl = (e) =>
	{
		setPasteUrl(e.target.value);
		setError({});
	};

	const extractVideoId = (url) =>
	{
		if (!url) return null;

		try
		{
			if (url.includes('youtu.be'))
			{
				return url.split('youtu.be/')[1]?.split(/[?#]/)[0] || null;
			}

			// Handle youtube.com/live/VIDEO_ID
			if (url.includes('youtube.com/live/'))
			{
				return url.split('youtube.com/live/')[1]?.split(/[?#]/)[0] || null;
			}
			// Handle youtu.be format
			if (url.includes('youtu.be'))
			{
				return url.split('youtu.be/')[1]?.split(/[?#]/)[0] || null;
			}

			// Handle youtube.com format
			const matchStandard = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);

			return matchStandard ? matchStandard[1] : null;
		}
		catch (error)
		{
			console.error('Error extracting video ID:', error);

			return null;
		}
	};

	const validateYouTubeUrl = (url) =>
	{
		if (!url) return false;

		// Extract video ID first
		const videoId = extractVideoId(url);

		// Validate video ID format (11 characters, alphanumeric with specific special chars)
		if (!videoId) return false;

		const videoIdPattern = /^[a-zA-Z0-9_-]{11}$/;

		return videoIdPattern.test(videoId);
	};

	const handleUploadUrl = async (e) =>
	{
		e?.preventDefault();
		const errorObj = {};

		try
		{
			if (!pasteUrl.trim())
			{
				errorObj.url = language?.enterYoutubeUrl;
				setError(errorObj);

				return;
			}

			const videoId = extractVideoId(pasteUrl);

			if (!videoId || !validateYouTubeUrl(pasteUrl))
			{
				errorObj.url = language?.validutubeUrl || 'Please enter a valid YouTube video URL';
				setError(errorObj);

				return;
			}

			// Construct canonical YouTube URL
			const canonicalUrl = `https://www.youtube.com/watch?v=${videoId}`;

			const videoInfo = await getYoutubeInfo(canonicalUrl);

			if (!videoInfo)
			{
				errorObj.url = 'Unable to fetch video information. Please check the URL and try again.';
				setError(errorObj);

				return;
			}

			const thumbnail = videoInfo?.thumbnail_url || (await generateThumbnailFrmUtube(canonicalUrl));

			if (type === 'content')
			{
				const newData = {
					url         : canonicalUrl,
					type        : 'video',
					mediaType   : 'youtube',
					key         : `${Date.now()}-${videoInfo.title}`,
					title       : videoInfo.title,
					name        : videoInfo.title,
					description : videoInfo.title,
					thumbnail,
					videoId // Add video ID to the data
				};

				setData((data) => ({ ...data, ...newData }));
			}
			else
			{
				const mediaObj = {
					url         : canonicalUrl,
					type        : 'youtube',
					title       : videoInfo.title,
					key         : 'youtube',
					description : videoInfo.title,
					thumbnail,
					videoId // Add video ID to the data
				};

				setYouTubeData({
					...youTubeData,
					media : [ mediaObj ],
					popup : false
				});
				handleClose();
			}
		}
		catch (error)
		{
			console.error('Error processing YouTube URL:', error);
			errorObj.url = 'An error occurred while processing the URL. Please try again.';
			setError(errorObj);
		}
	};

	return { handleUrl, handleUploadUrl };
};

export default useYoutubeURL;

// Old Code BKp
// const useYoutubeURL = (youtubeObj) =>
// {
// 	console.log('***************', youtubeObj);
// 	const { pasteUrl, setPasteUrl, edit, setYouTubeData, setData, youTubeData, setError, type, handleClose } = youtubeObj;
// 	const { language } = useContext(LanguageContext);
// 	const handleUrl = (e) =>
// 	{
// 		setPasteUrl(e.target.value);
// 	};

// 	const validateYouTubeUrl = () =>
// 	{
// 		const url = pasteUrl;

// 		if (url !== undefined || url !== '')
// 		{
// 			const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
// 			const playlistRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(playlist\?list=|watch\?v=[\w-]{11}&list=))[\w-]+$/;

// 			const match = url.match(regExp);
// 			const isPlaylist = playlistRegex.test(url);

// 			if (match && match[2].length === 11 && !isPlaylist) return true;
// 			else return false;
// 		}

// 		return false;
// 	};

// 	const handleUploadUrl = async (e) =>
// 	{
// 		e?.preventDefault();

// 		const errorObj = {};
// 		const response = pasteUrl !== '' && await getYoutubeInfo(pasteUrl);

// 		if (pasteUrl === '')
// 		{
// 			errorObj.url = language?.enterYoutubeUrl;
// 		}
// 		else if (pasteUrl !== '' && response === undefined)
// 		{
// 			errorObj.url = language?.validutubeUrl;
// 		}
// 		else if (!validateYouTubeUrl())
// 		{
// 			errorObj.url = 'Please upload youtube videos only, shorts and playlists are not allowed';
// 		}

// 		if (Object.keys(errorObj)?.length <= 0)
// 		{
// 			const thumbnailD = await generateThumbnailFrmUtube(pasteUrl);

// 			if (type === 'content')
// 			{
// 				const newData = {
// 					url         : pasteUrl,
// 					type        : 'video',
// 					mediaType   : 'youtube',
// 					key         : Date.now() + response?.title,
// 					title       : response?.title,
// 					name        : response?.title,
// 					description : response?.title,
// 					thumbnail   : thumbnailD
// 				};

// 				console.log('newdata ***************', newData);
// 				if (edit && Object.keys(edit)?.length > 0)
// 				{
// 					newData.replace = true;
// 					newData.index = edit.index;
// 				}

// 				setData((data) => ({ ...data, ...newData }));
// 			}
// 			else
// 			{
// 				const obj = { url: pasteUrl, type: 'youtube', title: response?.title, key: 'youtube', description: response?.title, thumbnail: thumbnailD };

// 				setYouTubeData({ ...youTubeData, media: [ obj ], popup: false });
// 				handleClose();
// 			}
// 		}
// 		setError(errorObj);
// 	};

// 	return { handleUrl, handleUploadUrl };
// };

// export default useYoutubeURL;